export const getPackagesWithCountQueryParams = ({
  buildingId,
  start,
  pageSize,
  query,
  status = '',
  startDate,
  endDate,
  sort,
  locations = [],
}) => {
  const params = new URLSearchParams()
  params.append('buildingId', buildingId)
  params.append('skip', start)
  params.append('limit', pageSize)
  if (query) params.append('search', query)
  if (status) params.append('status', status)
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)
  if (sort) params.append('sort', sort)
  if (locations.length > 0) params.append('location', locations)
  return params.toString()
}

export const getPackagesCSVQueryParams = ({
  buildingId,
  search,
  status = '',
  startDate,
  endDate,
  locations = [],
}) => {
  const params = new URLSearchParams()
  params.append('buildingId', buildingId)
  if (search) params.append('search', search)
  if (status) params.append('status', status)
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)
  if (locations.length > 0) params.append('location', locations)
  return params.toString()
}
